/**
 * Created by Michał Stawski on 2018-06-21.
 */

const initialState = {tables: {}};
const initialTable = {selected: [], initilized: false};

export const tableStateApi = {
  FILTER_ITEMS: 'FILTER_ITEMS',
  REGISTER_TABLE: 'REGISTER_TABLE',
};

export default function appState(state = initialState, action) {
  let nstate = {...state};
  switch (action.type) {
    case tableStateApi.REGISTER_TABLE:
      nstate.tables[action.name] = {...initialTable};
      return nstate;
    case tableStateApi.FILTER_ITEMS:
      nstate.tables[action.name] = {...nstate.tables[action.name]};
      nstate.tables[action.name].selected = action.selected;
      nstate.tables[action.name].initialized = true;
      return nstate;
    default:
      return state;
  }
}

export function tableState(state, tableName) {
  return state.tableState.tables[tableName];
};

export function registerTable(name){
  return {type: tableStateApi.REGISTER_TABLE, name};
}

export function filterTableItems(name, items){
  return {type: tableStateApi.FILTER_ITEMS, name, selected: items};
}
